var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-breadcrumb-cartao',{attrs:{"cartaoCustom":"","titulo":"Relatório de Produtividade","breadcrumb":_vm.bread,"icone":"file-text"}},[_c('div',{attrs:{"slot":"cartao"},slot:"cartao"},[_c('AnaliseProdutividade',{on:{"download":_vm.downloadHandler}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }